import { StickyNote } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router';

import PartyTabSection from '@/components/common/PartyTabSection';
import { useEmail } from '@/components/providers/EmailProvider/EmailProvider';
import useSelectedParty from '@/features/analysis/hooks/useSelectedParty';
import { PARTY_TAB_SECTIONS_MAX_ITEMS } from '@/features/party/constants';
import paths from '@/lib/paths';
import useLocalSettings from '@/stores/useLocalSettings';

import useNotes from '../../queries/hooks/useNotes';

import NoteItem from './NoteItem';

export default function RiskObjectsSection() {
  const { t } = useTranslation();

  const { onlyShowRelevant } = useLocalSettings();

  const party = useSelectedParty();
  const {
    analysis: {
      relevant: { noteIds },
    },
  } = useEmail();

  const { data: notes, isLoading } = useNotes(party?.id ?? '', {
    enabled: Boolean(party?.id),
  });

  const shownItems = onlyShowRelevant
    ? notes?.filter((note) => noteIds?.includes(note.activity_id))
    : notes?.slice(0, PARTY_TAB_SECTIONS_MAX_ITEMS);

  return (
    <PartyTabSection
      icon={StickyNote}
      title={t('NOTES_TITLE')}
      noItemsMessage={t('NOTES_EMPTY')}
      more={generatePath(paths.notes.overview)}
      isLoading={isLoading}
      totalItems={notes?.length ?? 0}
      relevantItems={noteIds?.length ?? 0}
    >
      {shownItems?.map((note) => (
        <NoteItem key={note.activity_id} note={note} />
      ))}
    </PartyTabSection>
  );
}
